import { Box, TextField, Button } from "@mui/material";
import { CreditCardInfo } from "types/generated/models";

interface IStripeDetailsViewProps {
    creditCardInfo: CreditCardInfo;
    setEditCardMode: (editMode: boolean) => void;
}

export default function StripeDetailsView({ setEditCardMode, creditCardInfo }: Readonly<IStripeDetailsViewProps>) {
    if (!creditCardInfo) {
        return null;
    }

    return (
        <Box sx={{ display: "flex", flexDirection: "column", gap: "24px" }} data-test-id="section_stripe_details_view">
            <Box sx={{ display: "flex", gap: "24px" }}>
                <Box sx={{ flex: "1 1 auto" }}>
                    <TextField
                        data-test-id="input_readonly_stripe_card_number"
                        label="Credit Card Number"
                        fullWidth
                        variant="outlined"
                        disabled
                        size="medium"
                        value={`•••• •••• •••• ${creditCardInfo.cardNumber}`}
                        slotProps={{
                            input: {
                                endAdornment: (
                                    <img
                                        src={`/images/cards/${creditCardInfo.brand}.svg`}
                                        alt="credit card brand logo"
                                        height={22}
                                    />
                                ),
                            },
                        }}
                    />
                </Box>
                <Box sx={{ flex: "0 0 auto", minWidth: "fit-content" }}>
                    <Button
                        data-test-id="button_enable_edit"
                        variant="contained"
                        size="medium"
                        onClick={() => setEditCardMode(true)}
                    >
                        Edit
                    </Button>
                </Box>
            </Box>
            <Box sx={{ display: "flex", gap: "24px" }}>
                <Box sx={{ flex: 1 }}>
                    <TextField
                        data-test-id="input_readonly_stripe_exp_date"
                        fullWidth
                        variant="outlined"
                        label="Exp. Date"
                        size="medium"
                        disabled
                        value={`${creditCardInfo.expMonth}/${creditCardInfo.expYear}`}
                    />
                </Box>
                <Box sx={{ flex: 1 }}>
                    <TextField
                        data-test-id="input_readonly_stripe_ccv"
                        fullWidth
                        size="medium"
                        variant="outlined"
                        label="CVV"
                        disabled
                        value="•••"
                    />
                </Box>
            </Box>
        </Box>
    );
}
